export const sessionStorageKeys = {
  isReminderOpen: 'isReminderOpen',
};
